<div class="reports-container">
  <div class="page-header">
    <div class="page-title" i18n>Reports</div>
    <div class="page-subtitle" *ngIf="!loading"><span i18n>Jobs in the last 30 days:</span> {{ totalJobCount }}</div>
  </div>

  <div *ngIf="loading" class="loading-container">
    <mat-spinner diameter="48"></mat-spinner>
    <span i18n>Loading jobs...</span>
  </div>

  <div *ngIf="!loading && totalJobCount === 0" class="empty-state">
    <mat-icon>inbox</mat-icon>
    <span i18n>No jobs found in the last 30 days.</span>
  </div>

  <ng-container *ngIf="!loading && totalJobCount > 0">
    <!-- ===== RUNNING JOBS TABLE ===== -->
    <mat-card class="section-card" *ngIf="runningGroup">
      <mat-card-header>
        <mat-card-title>
          <div class="section-header">
            <mat-icon class="status-running">play_circle</mat-icon>
            <span>Running Jobs</span>
            <span class="group-count">({{ runningGroup.jobs.length }})</span>
          </div>
        </mat-card-title>
      </mat-card-header>
      <mat-card-content>
        <div class="table-wrapper">
          <table mat-table [dataSource]="runningGroup.jobs" class="jobs-table">
            <ng-container *ngFor="let col of runningGroup.columns" [matColumnDef]="col">
              <th mat-header-cell *matHeaderCellDef>{{ formatColumnLabel(col) }}</th>
              <td mat-cell *matCellDef="let job">{{ formatCellValue(job[col], col) }}</td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="runningGroup.columns; sticky: true"></tr>
            <tr mat-row *matRowDef="let row; columns: runningGroup.columns"></tr>
          </table>
        </div>
      </mat-card-content>
    </mat-card>

    <div *ngIf="!runningGroup" class="no-running">
      <mat-icon class="status-running">play_circle</mat-icon>
      <span i18n>No jobs currently running.</span>
    </div>

    <!-- ===== SUCCEEDED BAR CHART ===== -->
    <mat-card class="section-card" *ngIf="succeededChart">
      <mat-card-header>
        <mat-card-title>
          <div class="section-header">
            <mat-icon class="status-succeeded">check_circle</mat-icon>
            <span>Succeeded Jobs</span>
            <span class="group-count">&mdash; {{ succeededChart.totalCount }} total in last 30 days</span>
          </div>
        </mat-card-title>
      </mat-card-header>
      <mat-card-content>
        <div class="chart-container">
          <div class="chart-bars" [style.height.px]="CHART_HEIGHT">
            <div class="bar-column" *ngFor="let day of succeededChart.days">
              <div class="bar-value" *ngIf="day.count > 0">{{ day.count }}</div>
              <div class="bar succeeded-bar" [style.height.px]="day.barHeight"></div>
            </div>
          </div>
          <div class="chart-labels">
            <div class="bar-label" *ngFor="let day of succeededChart.days">{{ day.date }}</div>
          </div>
        </div>
      </mat-card-content>
    </mat-card>

    <!-- ===== FAILED BAR CHART ===== -->
    <mat-card class="section-card" *ngIf="failedChart">
      <mat-card-header>
        <mat-card-title>
          <div class="section-header">
            <mat-icon class="status-failed">error</mat-icon>
            <span>Failed Jobs</span>
            <span class="group-count">&mdash; {{ failedChart.totalCount }} total in last 30 days</span>
          </div>
        </mat-card-title>
      </mat-card-header>
      <mat-card-content>
        <div class="chart-container">
          <div class="chart-bars" [style.height.px]="CHART_HEIGHT">
            <div class="bar-column" *ngFor="let day of failedChart.days">
              <div class="bar-value" *ngIf="day.count > 0">{{ day.count }}</div>
              <div class="bar failed-bar" [style.height.px]="day.barHeight"></div>
            </div>
          </div>
          <div class="chart-labels">
            <div class="bar-label" *ngFor="let day of failedChart.days">{{ day.date }}</div>
          </div>
        </div>
      </mat-card-content>
    </mat-card>
  </ng-container>
</div>
